var render = function render(){var _vm=this,_c=_vm._self._c;return _c('login-mobile',{attrs:{"form-data-mapper":_vm.requestDataMapper},on:{"after-login":_vm.handleAfterLogin}})
}
var staticRenderFns = []

export { render, staticRenderFns }